import { cn } from "@/lib/utils";

import InsertHorizonLine from "@/components/widget/editor/toolbar-buttons/insert-horizon-line";
import ListOrder from "@/components/widget/editor/toolbar-buttons/list-order";
import TextStyleControls from "@/components/widget/editor/toolbar-buttons/text-style-controls";

interface Props extends React.ComponentProps<"div"> {
  editorRef: React.RefObject<HTMLDivElement>;
}

const HomeTab: React.FC<Props> = ({ editorRef, className, ...props }) => {
  return (
    <div className={cn("flex items-center gap-x-3", className)} {...props}>
      <TextStyleControls editorRef={editorRef} />
      <ListOrder editorRef={editorRef} />
      <InsertHorizonLine editorRef={editorRef} />
    </div>
  );
};
export default HomeTab;
